/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificateStore } from '../model';
// @ts-ignore
import type { CertificateValidationResult } from '../model';
// @ts-ignore
import type { IssuerWithStore } from '../model';
/**
 * CertificateValidationApi - axios parameter creator
 * @export
 */
export const CertificateValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerGetIssuerCertificate: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateValidationControllerGetIssuerCertificate', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateValidationControllerGetIssuerCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/validation/getIssuerCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificate: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificate', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificate', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/validation/validateCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificateForEncryption: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificateForEncryption', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificateForEncryption', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/validation/validateCertificateForEncryption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificateForSigning: async (store: CertificateStore, thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'store' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificateForSigning', 'store', store)
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('certificateValidationControllerValidateCertificateForSigning', 'thumbprint', thumbprint)
            const localVarPath = `/api/certificate/validation/validateCertificateForSigning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (store !== undefined) {
                localVarQueryParameter['store'] = store;
            }

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificate: async (thumbprint?: string, chain?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/validation/validateExternalCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


            if (chain !== undefined) { 
                localVarFormParams.append('chain', chain as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificateForEncryption: async (thumbprint?: string, chain?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/validation/validateExternalCertificateForEncryption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


            if (chain !== undefined) { 
                localVarFormParams.append('chain', chain as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificateForSigning: async (thumbprint?: string, chain?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/certificate/validation/validateExternalCertificateForSigning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


            if (chain !== undefined) { 
                localVarFormParams.append('chain', chain as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificateValidationApi - functional programming interface
 * @export
 */
export const CertificateValidationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificateValidationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerGetIssuerCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerWithStore>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerGetIssuerCertificate(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerGetIssuerCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateCertificate(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateCertificateForEncryption(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateCertificateForEncryption(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateCertificateForEncryption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateCertificateForSigning(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateCertificateForSigning(store, thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateCertificateForSigning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateExternalCertificate(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateExternalCertificate(thumbprint, chain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateExternalCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint, chain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateExternalCertificateForEncryption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async certificateValidationControllerValidateExternalCertificateForSigning(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.certificateValidationControllerValidateExternalCertificateForSigning(thumbprint, chain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateValidationApi.certificateValidationControllerValidateExternalCertificateForSigning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificateValidationApi - factory interface
 * @export
 */
export const CertificateValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificateValidationApiFp(configuration)
    return {
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerGetIssuerCertificate(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<IssuerWithStore> {
            return localVarFp.certificateValidationControllerGetIssuerCertificate(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificate(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateCertificate(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificateForEncryption(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateCertificateForEncryption(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateStore} store 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateCertificateForSigning(store: CertificateStore, thumbprint: string, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateCertificateForSigning(store, thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificate(thumbprint?: string, chain?: File, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateExternalCertificate(thumbprint, chain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint?: string, chain?: File, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint, chain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [thumbprint] 
         * @param {File} [chain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        certificateValidationControllerValidateExternalCertificateForSigning(thumbprint?: string, chain?: File, options?: any): AxiosPromise<CertificateValidationResult> {
            return localVarFp.certificateValidationControllerValidateExternalCertificateForSigning(thumbprint, chain, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificateValidationApi - object-oriented interface
 * @export
 * @class CertificateValidationApi
 * @extends {BaseAPI}
 */
export class CertificateValidationApi extends BaseAPI {
    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerGetIssuerCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerGetIssuerCertificate(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateCertificate(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateCertificate(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateCertificateForEncryption(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateCertificateForEncryption(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateStore} store 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateCertificateForSigning(store: CertificateStore, thumbprint: string, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateCertificateForSigning(store, thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [thumbprint] 
     * @param {File} [chain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateExternalCertificate(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateExternalCertificate(thumbprint, chain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [thumbprint] 
     * @param {File} [chain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateExternalCertificateForEncryption(thumbprint, chain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [thumbprint] 
     * @param {File} [chain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateValidationApi
     */
    public certificateValidationControllerValidateExternalCertificateForSigning(thumbprint?: string, chain?: File, options?: RawAxiosRequestConfig) {
        return CertificateValidationApiFp(this.configuration).certificateValidationControllerValidateExternalCertificateForSigning(thumbprint, chain, options).then((request) => request(this.axios, this.basePath));
    }
}

